import React, { useState, useEffect } from 'react';
import { Box, Typography, Paper } from '@mui/material';
import FarmTasks from './FarmTasks';

// Define a worker type to match what's needed for the FarmTasks component
interface Worker {
  id: string;
  name: string;
  role: string;
  specialization: string[];
}

// Props interface
interface FarmTasksIntegrationProps {
  farmId: string;
}

/**
 * Component that integrates the FarmTasks component with the existing worker management system
 * Connects worker data from the worker management to the task system
 * @param props Component props
 * @returns Task management integrated with worker system
 */
const FarmTasksIntegration: React.FC<FarmTasksIntegrationProps> = ({ farmId }) => {
  // Example worker data that would be fetched or passed from parent component
  // In a real implementation, this would come from your worker management system
  const [workers, setWorkers] = useState<Worker[]>([
    {
      id: '1',
      name: 'John Doe',
      role: 'Farm Manager',
      specialization: ['Crop Management', 'Animal Care'],
    },
    {
      id: '2',
      name: 'Alice Smith',
      role: 'Animal Handler',
      specialization: ['Animal Care'],
    },
    {
      id: '3',
      name: 'Robert Johnson',
      role: 'Field Worker',
      specialization: ['Planting', 'Harvesting'],
    },
    {
      id: '4',
      name: 'Emily Williams',
      role: 'Equipment Operator',
      specialization: ['Equipment', 'Maintenance'],
    },
  ]);

  // In a real implementation, you would fetch worker data here
  useEffect(() => {
    // Example API call
    // const fetchWorkers = async () => {
    //   try {
    //     const response = await fetch(`/api/farms/${farmId}/workers`);
    //     const data = await response.json();
    //     setWorkers(data);
    //   } catch (error) {
    //     console.error('Error fetching workers:', error);
    //   }
    // };
    // 
    // fetchWorkers();
  }, [farmId]);

  return (
    <Box sx={{ p: 3 }}>
      <Paper elevation={2} sx={{ p: 3, mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          Farm Tasks and Worker Assignments
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Manage farm tasks and assign workers based on their specializations. The system will recommend 
          workers for tasks based on their expertise, helping you optimize worker assignments.
        </Typography>
      </Paper>
      
      {/* Pass workers to the FarmTasks component */}
      <FarmTasks farmId={farmId} workers={workers} />
    </Box>
  );
};

export default FarmTasksIntegration; 